import { store } from '@/store'

export default {
  //изменение задачи
  tasks_put_task(data, vue) {
    if (vue.$route.name != 'Task' && vue.$route.name != 'Tasks') return;
    if (data && data.data && data.data.id) store.dispatch('tasks/getTask', data.data.id).then(r => vue.$root.$emit('update-task', r));
  },

  //добавление задачи
  tasks_add_task(data, vue) {
    if (vue.$route.name != 'Task' && vue.$route.name != 'Tasks') return;
    if (data && data.data && data.data.id) store.dispatch('tasks/getTask', data.data.id).then(r => vue.$root.$emit('update-task-list', r));
  },

  //удаление задачи
  tasks_delete_task(data, vue) {
    if (vue.$route.name != 'Task' && vue.$route.name != 'Tasks') return;
    if (data && data.data && data.data.id) vue.$root.$emit('delete-task', data.data.id);
  },

  tasks_put_task_status(data, vue) {
    if (vue.$route.name != 'Task' && vue.$route.name != 'Tasks') return;
    vue.$root.$emit('update-task-menu');
  },
  tasks_add_task_status(data, vue) {
    if (vue.$route.name != 'Task' && vue.$route.name != 'Tasks') return;
    vue.$root.$emit('update-task-menu');
  },
  tasks_delete_task_status(data, vue) {
    if (vue.$route.name != 'Task' && vue.$route.name != 'Tasks') return;
    vue.$root.$emit('update-task-menu');
  },
  tasks_put_task_project(data, vue) {
    if (vue.$route.name != 'Task' && vue.$route.name != 'Tasks') return;
    vue.$root.$emit('update-task-menu');
  },
  tasks_add_task_project(data, vue) {
    if (vue.$route.name != 'Task' && vue.$route.name != 'Tasks') return;
    vue.$root.$emit('update-task-menu');
  },
  tasks_delete_task_project(data, vue) {
    if (vue.$route.name != 'Task' && vue.$route.name != 'Tasks') return;
    vue.$root.$emit('update-task-menu');
  },
  tasks_add_task_group(data, vue) {
    if (vue.$route.name != 'Task' && vue.$route.name != 'Tasks') return;
    vue.$root.$emit('update-task-menu');
  },
  tasks_put_task_group(data, vue) {
    if (vue.$route.name != 'Task' && vue.$route.name != 'Tasks') return;
    vue.$root.$emit('update-task-menu');
  },
  tasks_delete_task_group(data, vue) {
    if (vue.$route.name != 'Task' && vue.$route.name != 'Tasks') return;
    vue.$root.$emit('update-task-menu');
  },


}


// WEBPACK FOOTER //
// ./src/modules/tasks/pusher.js